export const defaultBaseSliderPropMapping = (props) => {
    const existingRules = props.rules ?? {};
    const mapped = {
        ...props,
        rules: { ...existingRules },
        defaultValue: null,
    };
    mapped.rules.max = {
        value: props.to ?? 100,
        message: "invalidMax",
    };
    mapped.rules.min = {
        value: props.from ?? 0,
        message: "invalidMin",
    };
    mapped.rules.validate = (value) => value % (props.steps ?? 1) !== 0 ? "invalidValue" : true;
    return mapped;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGliLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2xpZGVyL2xpYi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLENBQUMsTUFBTSw0QkFBNEIsR0FFckMsQ0FBQyxLQUFLLEVBQUUsRUFBRTtJQUNaLE1BQU0sYUFBYSxHQUFHLEtBQUssQ0FBQyxLQUFLLElBQUksRUFBRSxDQUFDO0lBQ3hDLE1BQU0sTUFBTSxHQUFHO1FBQ2IsR0FBRyxLQUFLO1FBQ1IsS0FBSyxFQUFFLEVBQUUsR0FBRyxhQUFhLEVBQUU7UUFDM0IsWUFBWSxFQUFFLElBQUk7S0FDbkIsQ0FBQztJQUVGLE1BQU0sQ0FBQyxLQUFLLENBQUMsR0FBRyxHQUFHO1FBQ2pCLEtBQUssRUFBRSxLQUFLLENBQUMsRUFBRSxJQUFJLEdBQUc7UUFDdEIsT0FBTyxFQUFFLFlBQVk7S0FDdEIsQ0FBQztJQUVGLE1BQU0sQ0FBQyxLQUFLLENBQUMsR0FBRyxHQUFHO1FBQ2pCLEtBQUssRUFBRSxLQUFLLENBQUMsSUFBSSxJQUFJLENBQUM7UUFDdEIsT0FBTyxFQUFFLFlBQVk7S0FDdEIsQ0FBQztJQUVGLE1BQU0sQ0FBQyxLQUFLLENBQUMsUUFBUSxHQUFHLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FDaEMsS0FBSyxHQUFHLENBQUMsS0FBSyxDQUFDLEtBQUssSUFBSSxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO0lBRTNELE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUMsQ0FBQyJ9